/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.33/esri/copyright.txt for details.
*/
const e="esri-search-result-renderer",r={base:e,moreResults:`${e}--more-results`};export{r as css};
